<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :maskClosable="false" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="merchantName" >
        <span slot="label" >
          <a-tooltip>
            商家名称<template slot="title">商家名称</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.merchantName" :maxLength="255" :placeholder="$t('请输入')+'商家名称'" />
      </a-form-model-item>
      <a-form-model-item prop="merchantLogo" >
        <span slot="label" >
          <a-tooltip>
            商家logo<template slot="title">商家logo</template>
          </a-tooltip>
        </span>
        <oss-upload-single v-model="form.merchantLogo" prefix="merchant" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="merchantBackground" >
        <span slot="label" >
          <a-tooltip>
            商家背景图<template slot="title">商家背景图</template>
          </a-tooltip>
        </span>
        <oss-upload-single v-model="form.merchantBackground" prefix="merchant" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="merchantAreax" >
        <span slot="label" >
          <a-tooltip>
            商家所在地<template slot="title">商家所在地</template>
          </a-tooltip>
        </span>
        <a-cascader :options="areaList"
                    :field-names="{ label: 'areaName', value: 'areaId', children: 'children'}"
                    :placeholder="$t('请选择')+'商家所在地'"
                    style="width: 100%" v-model="areaSelected" allowClear @change="onAreaChange">
        </a-cascader>
      </a-form-model-item>
      <a-form-model-item prop="merchantAddress" >
        <span slot="label" >
          <a-tooltip>
            详细地区<template slot="title">详细地区</template>
          </a-tooltip>
        </span>
        <div id="amap" style="height: 450px; width: 470px">
          <merchant-map ref="merchantMap" @updateLocationMap="updateLocationMap"   style="height: 100%;" />
        </div>
      </a-form-model-item>


      <a-form-model-item prop="businessType" >
        <span slot="label" >
          <a-tooltip>
            经营类型<template slot="title">商城或同城</template>
          </a-tooltip>
        </span>
        <a-select v-model="form.businessType" disabled :placeholder="$t('请输入')+'经营类型'" >
          <a-select-option v-for="(item, index) in customDict.BusinessTypeEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="industryId" >
        <span slot="label" >
          <a-tooltip>
            主营行业<template slot="title">主营行业id</template>
          </a-tooltip>
        </span>
        <a-select v-model="form.industryId" :placeholder="$t('请输入')+'主营行业'" >
          <a-select-option v-for="(item, index) in industryList" :value="item.id" :key="index">
            {{ item.categoryName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="timeOfEntry" >
        <span slot="label" >
          <a-tooltip>
            入驻时长<template slot="title">入驻时长</template>
          </a-tooltip>
        </span>
        <a-select v-model="form.timeOfEntry" disabled :placeholder="$t('请输入')+'入驻时长'" >
          <a-select-option v-for="(item, index) in this.timeEntryList" :value="item.id" :key="index">
            {{ item.duration }}年
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-row>
        <a-col :span="16">
          <a-form-model-item :label="$t('标签')" prop="merchantTagList" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
            <a-select style="flex: 1" v-model="form.merchantTagList"   mode="multiple" >
              <a-select-option v-for="(item, index) in goodsTagInputList" :value="item" :key="index">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="4">
          <editable-cell :name="$t('添加')+$t('标签')" @submit="(data)=>addTag(data)"/>
        </a-col>
      </a-row>

      <a-form-model-item prop="customerServiceMobile" >
        <span slot="label" >
          <a-tooltip>
            客服电话<template slot="title">客服电话</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.customerServiceMobile" :maxLength="32" :placeholder="$t('请输入')+'客服电话'" />
      </a-form-model-item>
      <a-form-model-item prop="businessTime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('营业时间')}}<template slot="title">{{$t('营业时间')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.businessTime" :maxLength="32" :placeholder="$t('请输入')+$t('营业时间') " />
      </a-form-model-item>
      <a-form-model-item prop="merchantDescription" >
        <span slot="label" >
          <a-tooltip>
            商家简介<template slot="title">商家简介</template>
          </a-tooltip>
        </span>
        <a-input type="textarea" v-model="form.merchantDescription" :placeholder="$t('请输入')"  allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="qualification" >
        <span slot="label" >
          <a-tooltip>
            商家资质<template slot="title">商家资质</template>
          </a-tooltip>
        </span>
        <Editor ref="qualificationEditor" v-model="form.qualification" style="height: 600px" :placeholder="$t('请输入')"  allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getMerchantMerchant, addMerchantMerchant, updateMerchantMerchant } from '@/api/merchant/merchantMerchant'
import { listIndustry } from '@/api/merchant/industry'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";
import {areaListTree} from "@/api/logistics";
import {listEntry} from "@/api/merchant/entry";
import Editor from "@/components/Editor/Editor.vue";
import EditableCell from "@/components/EditableCell/index.vue";
import MerchantMap from "@/views/common/map.vue";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    MerchantMap,
    EditableCell,
    Editor,
    OssUploadSingle,
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      areaList: [],
      areaSelected: [],
      timeEntryList: [],
      industryList: [],
      goodsTagInputList: [],
      // 表单参数
      form: {
        id: null,
        merchantTagList: [],
        merchantName: null,
        merchantLogo: null,
        merchantBackground: null,
        merchantAreax: null,
        merchantAddress: null,
        merchantStatus: 0,
        merchantDescription: null,
        businessType: null,
        merchantLongitude: null,
        merchantLatitude: null,
        marginAmount: null,
        industryId: null,
        timeOfEntry: null,
        customerServiceMobile: null,
        imgDetail: null,
        createTime: null,
        remark: null,
        businessTime: null,
        qualification: undefined,
        localeFieldMap: {},

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        merchantName: [
          { required: true, message: '商家名称'+this.$t('不能为空'), trigger: 'blur' }
        ],
        merchantLogo: [
          { required: true, message: '商家logo'+this.$t('不能为空'), trigger: 'blur' }
        ],
        merchantBackground: [
          { required: true, message: '商家背景图'+this.$t('不能为空'), trigger: 'blur' }
        ],
        merchantAddress: [
          { required: true, message: '详细地区'+this.$t('不能为空'), trigger: 'blur' }
        ],
        merchantStatus: [
          { required: true, message: '商家状态'+this.$t('不能为空'), trigger: 'blur' }
        ],
        businessType: [
          { required: true, message: '经营类型'+this.$t('不能为空'), trigger: 'change' }
        ],
        merchantAreax: [
          { required: true, message: '商家所在地 '+this.$t('不能为空'), trigger: 'change' }
        ],
        industryId: [
          { required: true, message: '主营行业id'+this.$t('不能为空'), trigger: 'blur' }
        ],
        timeOfEntry: [
          { required: true, message: '入驻时长,外键'+this.$t('不能为空'), trigger: 'blur' }
        ],
        customerServiceMobile: [
          { required: true, message: '客服电话'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.getAreaTree()
    this.getTimeEntry()
  },
  computed: {
    ...mapGetters(['customDict','userInfo'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
      this.$refs.merchantMap.initMarker(null, null, null, null);
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        merchantTagList: [],
        merchantName: null,
        merchantLogo: null,
        merchantBackground: null,
        merchantAreax: null,
        merchantAddress: null,
        merchantStatus: 0,
        merchantDescription: null,
        businessType: null,
        merchantLongitude: null,
        merchantLatitude: null,
        marginAmount: null,
        industryId: null,
        timeOfEntry: null,
        customerServiceMobile: null,
        imgDetail: null,
        createTime: null,
        remark: null,
        businessTime: null,
        qualification: undefined,
        localeFieldMap: {},
      }
      this.goodsTagInputList = []
      this.areaSelected = []
    },
    getAreaTree() {
      areaListTree().then(response => {
        this.areaList = response.data
      })
    },
    initMap(){
      let longitude = this.form.merchantLongitude
      let latitude = this.form.merchantLatitude
      let areac = this.form.merchantAreax
      let detailedAddress = this.form.merchantAddress
      this.$refs.merchantMap.initMarker(longitude, latitude, areac, detailedAddress);
    },
    updateLocationMap(data) {
      console.log('地图选点',data)
      this.form.merchantLatitude = data.lat
      this.form.merchantLongitude = data.lon
      this.form.merchantAddress=data.orgAddr
    },
    onAreaChange(value, selectedOptions) {
      this.form.merchantAreax = value[2]
      console.log('onAreaChange',this.form.merchantAreax)
      //初始化地图
      this.$refs.merchantMap.initMarker(selectedOptions[2].longitude, selectedOptions[2].latitude, value[1], '');
    },
    getTimeEntry() {
      listEntry({}).then(response => {
        this.timeEntryList = response.data
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMerchantMerchant({"id":id}).then(response => {
        this.form = response.data
        this.areaSelected.push(this.form.merchantAreax.substring(0, 2) + '0000');
        this.areaSelected.push(this.form.merchantAreax.substring(0, 4) + '00');
        this.areaSelected.push(this.form.merchantAreax);
        this.open = true
        this.formTitle = this.$t('修改')
        this.getIndustryList(this.form.merchantType)
        this.$nextTick(()=>{
          this.initMap()
        })
      })
    },
    getIndustryList(merchantType) {
      listIndustry({merchantType:merchantType}).then(response => {
        this.industryList = response.data
      })
    },
    addTag(remark) {
      if (!this.form.merchantTagList) {
        this.form.merchantTagList=[]
      }
      this.goodsTagInputList.push(remark);
      this.form.merchantTagList.push(remark)

    },

    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateMerchantMerchant(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3);
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addMerchantMerchant(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
